<!-- Change password div -->

<div class="relative flex flex-grow items-center justify-center h-full m-auto dark-gradient-bg">
  <div
    class="flex flex-col flex-grow justify-start items-start bg-[#1d232b] rounded-lg absolute top-0 bottom-0 left-0 right-0 mx-5 my-5">
    <div class="flex flex-row items-center mt-10 cursor-pointer" (appClickableDirective)="goBack()">
      <img class="ml-10" src="../../../../assets/images/customer_screens/back arrow.svg" alt="Back Arrow" />
      <span class="text-white ml-4">Back</span>
    </div>

    <div class="flex flex-col items-center justify-center w-full h-full  flex-grow  ">
      <div
        class="flex sm:flex-col md:flex-row justify-center items-center flex-grow absolute end-0 start-0 p-5 mb-10 "
      >
        <div class=" w-1/3 flex justify-center items-center sm:mt-8  md:h-full">
         <img  src="../../../../assets/images/secondary-user.png" class="sm:h-20 sm:w-20 md:w-28 md:h-28 lg:w-40 lg:h-40" alt="secondary-user"
         >
        </div>
        <div class="relative flex-grow  h-full ">
          <div
            class="h-full flex flex-col justify-center items-center md:items-start md:ms-8"
          >
            <form
              [formGroup]="sendInviteForm"
              class="mt-5"
              (ngSubmit)="onSubmit()"
            >
              <div class="flex flex-col mb-6">
                <span class="text-lg font-medium mb-2 text-white w-64 md:w-auto gradient-text">{{ "add_secondary_user" |
                  translate }}</span>
                <label class="block text-white mb-2 opacity-80 mt-8"  for="name" >{{ "name" | translate
                  }}</label>
                <div class="flex flex-col md:flex-row flex-grow md:space-x-4">
                  <input formControlName="name"
                    class="w-64 box-border border border-gray-300 rounded-2xl py-2 px-3 text-white leading-tight bg-[#212932]"
                    id="name" type="text" placeholder="******" />
                </div>
                @if( sendInviteForm.controls.name.errors?.['required'] &&
                sendInviteForm.controls.name.touched){
                <div>
                  <p class="text-red-500 text-xs">Name is required.</p>
                </div>}
              </div>

              <div class="mt-6">
                <div>
                  <label class="block text-white font mb-2 opacity-80" for="email">{{ "email" | translate }}</label>
                  <input formControlName="email"
                    class="w-64 box-border border border-gray-300 rounded-2xl py-2 px-3 text-white leading-tight bg-[#212932]"
                    id="email" type="email" placeholder="********" />
                  @if( sendInviteForm.controls.email.errors?.['required'] &&
                  sendInviteForm.controls.email.touched){
                  <div>
                    <p class="text-red-500 text-xs">Email is required.</p>
                  </div>}
                  @if (sendInviteForm.controls.email.errors?.['email']) {
                  <div>
                    <p class="text-red-500 text-xs">Invalid email address.</p>
                  </div>}
                </div>
              </div>
              <div class="mt-6">
                <label class="block text-white font mb-2 opacity-80" for="mobile_number">{{ "mobile_number" | translate
                  }}</label>
                <input formControlName="phoneNumber"
                  class="w-64 box-border border border-gray-300 rounded-2xl py-2 px-3 text-white leading-tight bg-[#212932]"
                  id="mobile_number" type="text" placeholder="********" />
                @if (sendInviteForm.controls.phoneNumber.errors?.['required'] &&
                sendInviteForm.controls.phoneNumber.touched) {
                <div>
                  <p class="text-red-500 text-xs">Phone no. is required.</p>
                </div>}
              </div>

              <button
                class="bg-dark-accent-secondary hover:bg-blue-700 text-white font py-2 px-4 rounded-xl md:w-auto w-full border-none mt-6"
                type="submit" [ngClass]="{
                  ' opacity-35': !sendInviteForm.valid
                }" [disabled]="!sendInviteForm.valid">
                {{ "send_invite" | translate }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>